import React from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import ProfPic from '../Rating/profpic'
import RatingFeed from '../Rating/ratingfeed'

const Styles = styled.div`
    max-width: 680px;
    margin: 24px auto;
    padding: 0 16px;
`

const ProfileHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;

    h2 {
        margin: 0;
        font-size: 1.4em;
        font-weight: 600;
    }
`

export default function UserProfilePage() {
    const { username } = useParams()

    return (
        <Styles>
            <ProfileHeader>
                <ProfPic username={username} height='64px' width='64px'/>
                <h2>{username}</h2>
            </ProfileHeader>
            <RatingFeed owner={username}/>
        </Styles>
    )
}
